// @flow
import { type StatelessFunctionalComponent as ComponentType } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { createHeader } from '@tablekit/typography';
import { color, SPACING } from '@tablekit/theme';
import { DESKTOP_BREAKPOINT, LAPTOP_BREAKPOINT } from '../utils/theme';

const alignSwitch = (left = 'left', center = 'center', right = 'right') => ({
  align,
  theme: { isRtl } = {}
}) => {
  if (align === 'right') return isRtl ? left : right;
  if (align === 'left') return isRtl ? right : left;
  return center;
};

export const SEPERATOR_HEIGHT = '5px';

const Title: ComponentType<{
  align?: 'left' | 'right' | 'center'
}> = styled(
  createHeader('h2', {
    [DESKTOP_BREAKPOINT]: 'L9',
    [LAPTOP_BREAKPOINT]: 'L6',
    default: 'L5'
  })
)`
  display: flex;
  position: relative;
  justify-content: ${alignSwitch('flex-start', 'center', 'flex-start')};
  text-align: ${alignSwitch('left', 'center', 'left')};
  @media ${LAPTOP_BREAKPOINT} {
    // Flex and H3 text-align don't play nice...
    justify-content: ${alignSwitch('flex-start', 'center', 'flex-end')};
    text-align: ${alignSwitch()};
  }
  padding-bottom: calc(${SEPERATOR_HEIGHT} + ${SPACING.L2});
  margin-bottom: ${SPACING.L4};

  &:after {
    content: '';
    position: absolute;
    left: 0;
    ${alignSwitch(
      '',
      css`
        left: 50%;
        transform: translateX(-50%);
      `,
      ''
    )};
    @media ${LAPTOP_BREAKPOINT} {
      ${alignSwitch(
        'left: 0',
        '',
        css`
          right: 0;
          left: auto;
        `
      )};
    }
    bottom: 0;
    height: ${SEPERATOR_HEIGHT};
    width: 205px;
    background: ${color('accent')};
  }
`;

export default Title;
